(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-intro"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sm-read-more')) {
    class SmReadMore extends HTMLElement {
      connectedCallback() {
        this.text = this.querySelector('.collection-intro__text');
        this.button = this.querySelector('.collection-intro__toggle');
        if (!this.text || !this.button) return;

        this.classList.add('is-clamped');
        this.button.addEventListener('click', () => this.toggle());
        this.update = this.update.bind(this);
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.text);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      /* The button only shows when the text is actually cut. */
      update() {
        if (this.classList.contains('is-expanded')) return;
        const cut = this.text.scrollHeight > this.text.clientHeight + 1;
        this.button.hidden = !cut;
      }

      toggle() {
        const expanded = this.classList.toggle('is-expanded');
        this.classList.toggle('is-clamped', !expanded);
        this.button.setAttribute('aria-expanded', String(expanded));
        this.button.textContent = expanded ? this.button.dataset.labelLess : this.button.dataset.labelMore;
        if (!expanded) this.update();
      }
    }

    customElements.define('sm-read-more', SmReadMore);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
